import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { TrustMemberHistory } from '../../Models/Models/Customer/TrustMemberHistory';
import { BulkTrustMemberHistorySearchResult } from '../../Models/Models/Customer/BulkTrustMemberHistorySearchResult';
import { TrustMemberBulkRequest } from '../../Models/Models/Customer/TrustMemberBulkRequest';

declare var IS_RUNNING_IN_APP_POOL;

export class TrustMemberHistoryClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number, accountId: number, organisationId: number): Promise<Array<TrustMemberHistory>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/TrustMemberHistory/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, accountId: accountId, organisationId: organisationId }

    return AjaxWrapper.get<Array<TrustMemberHistory>, any>(url, data);
  }
  public post(request: TrustMemberBulkRequest): Promise<Array<BulkTrustMemberHistorySearchResult>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/TrustMemberHistory/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { request: request }

    return AjaxWrapper.post<Array<BulkTrustMemberHistorySearchResult>, any>(url, data);
  }
}

